module.exports = __webpack_public_path__ + "img/FC_Template_Retired_Small.ddf0d99c.png";